import { twMerge } from "tailwind-merge"

type CnInput =
  | Record<string, boolean | string | null | undefined>
  | string
  | string[]

const hasOwn = {}.hasOwnProperty

/**
 * Utility function that produces a single className from
 * more than one string/array/object of classes. Used to mix together
 * classes for an element.
 */
function cn(...input: (CnInput | false | null | undefined)[]): string {
  const classes = []

  for (const arg of input) {
    if (!arg) continue
    const argType = typeof arg

    if (argType === "string" || argType === "number") {
      classes.push(arg)
    } else if (Array.isArray(arg)) {
      if (arg.length > 0) {
        // eslint-disable-next-line prefer-spread
        const inner = cn.apply(null, arg)
        if (inner) {
          classes.push(inner)
        }
      }
    } else if (argType === "object") {
      if (
        arg.toString !== Object.prototype.toString &&
        !arg.toString.toString().includes("[native code]")
      ) {
        classes.push(arg.toString())
        continue
      }

      const objectArgument = arg as Record<string, unknown>
      for (const key in objectArgument) {
        if (hasOwn.call(objectArgument, key) && objectArgument[key]) {
          classes.push(key)
        }
      }
    }
  }

  return twMerge(classes.join(" "))
}

export default cn
